import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useAnalytics from 'utils/useAnalytics/useAnalytics';

const TrackPageView = () => {
  const { pathname, search } = useLocation();
  const { logEvent } = useAnalytics();

  useEffect(() => {
    logEvent('$pageview', {
      $current_url: window.location.href,
    });
  }, [logEvent, pathname, search]);

  return null;
};

export default TrackPageView;
